import type { MhElement } from '../../shared/interfaces';

export const getElements = (form: HTMLFormElement) => {
    const anchors = Array.from(form.querySelectorAll(`[data-mh]`));

    const elements: Record<string, MhElement> = {};

    anchors.forEach((anchor) => {
        const infoName = anchor.getAttribute(`data-mh`);
        if (!infoName) {
            throw new Error(`You must fill in the value of data-mh attribute.`);
        }

        if (!(anchor instanceof HTMLInputElement) && !(anchor instanceof HTMLSelectElement)) {
            elements[infoName] = {
                input: undefined,
                anchor,
                feedback: undefined,
            };
            return;
        }

        elements[infoName] = {
            input: anchor,
            anchor,
            feedback: undefined,
        };
    });

    return elements;
};
